import { render } from "./rep320.vue?vue&type=template&id=7c56ae72"
import script from "./rep320.vue?vue&type=script&lang=js"
export * from "./rep320.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__